import React, { useEffect } from "react";
import PriceSiteLayout from "./PriceSiteLayout";

export default function PricePrivacy() {
  useEffect(() => { document.title = "Politique de confidentialité · Price Covoiturage"; }, []);
  const today = new Date().toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" });
  return (
    <PriceSiteLayout>
      <main className="mx-auto max-w-3xl px-5 py-14">
        <h1 className="font-[Outfit] text-4xl font-black leading-tight sm:text-5xl">Politique de confidentialité</h1>
        <p className="mt-3 text-sm" style={{ color: "rgba(30,9,16,0.6)" }}>Dernière mise à jour : {today}</p>

        <div className="mt-10 max-w-none font-[Manrope] text-[15px] leading-relaxed" style={{ color: "rgba(30,9,16,0.85)" }}>
          <p>Price Covoiturage s&apos;engage à protéger la vie privée de ses utilisateurs. Cette politique explique quelles données sont collectées, pourquoi, et comment tu peux les gérer.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>1. Données collectées</h2>
          <ul className="mt-3 list-disc pl-6 space-y-1">
            <li>Identité : nom, prénom, email, numéro de téléphone.</li>
            <li>Position géographique : uniquement pendant tes trajets, pour te mettre en relation avec des covoitureurs proches.</li>
            <li>Paiement : les informations de carte sont traitées et stockées par Stripe, jamais par Price.</li>
            <li>Usage : logs techniques (device, version de l&apos;app) pour le debug.</li>
          </ul>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>2. Base légale</h2>
          <p>Exécution du contrat (mise en relation covoitureur/passager) et obligations légales (facturation, KYC via Stripe Connect).</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>3. Partage des données</h2>
          <p>Aucune donnée n&apos;est vendue. Elles sont partagées uniquement avec :</p>
          <ul className="mt-3 list-disc pl-6 space-y-1">
            <li>Stripe (paiement)</li>
            <li>OneSignal (envoi des notifications push)</li>
            <li>Mapbox (calcul d&apos;itinéraire)</li>
            <li>Autorités légales sur réquisition</li>
          </ul>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>4. Durée de conservation</h2>
          <p>Données de compte : tant que ton compte est actif. Données de trajets : 3 ans après le dernier trajet (obligation légale française).</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>5. Tes droits</h2>
          <p>Conformément au RGPD, tu peux à tout moment demander l&apos;accès, la rectification, la portabilité ou la suppression de tes données. La suppression est aussi disponible directement dans l&apos;app (menu &gt; Supprimer mon compte).</p>
          <p>Pour toute demande : <a href="mailto:contact@pricecovoit.fr" className="font-black" style={{ color: "#F86A78" }}>contact@pricecovoit.fr</a></p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>6. Cookies</h2>
          <p>Le site pricecovoit.fr n&apos;utilise pas de cookies de tracking. Seuls des cookies techniques strictement nécessaires (session, préférences) peuvent être déposés.</p>

          <h2 className="mt-10 mb-3 font-[Outfit] text-2xl font-black" style={{ color: "#1E0910" }}>7. Contact</h2>
          <p>Responsable de traitement : Price Covoiturage<br />Email : <a href="mailto:contact@pricecovoit.fr" className="font-black" style={{ color: "#F86A78" }}>contact@pricecovoit.fr</a></p>
        </div>
      </main>
    </PriceSiteLayout>
  );
}
